var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sample-code-group"},_vm._l((_vm.codeGroup.codes),function(code,i){return _c('div',{key:i,staticClass:"sample-code-group-item"},[_c('CodeDisplay',{attrs:{"code":code,"showTitle":_vm.codeGroup.codes.length > 1}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }